// extracted by mini-css-extract-plugin
export default {"Form":"SignInUp_Form__I6ik4","account":"SignInUp_account__kxDzO","button":"SignInUp_button__MB41-"};